module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 4.84331","quantity":0.04843},{"color":"#9dc4b5","label":" 4.84331- 7.89473","quantity":0.07895},{"color":"#e6efc3","label":" 7.89473- 9.21014","quantity":0.0921},{"color":"#ffe89e","label":" 9.21014- 10.70238","quantity":0.10702},{"color":"#f5af7f","label":" 10.70238- 12.88164","quantity":0.12882},{"color":"#ed6d32","label":" 12.88164- 29.68184","quantity":0.29682}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_100_return_20.json
// module id = Wv9v
// module chunks = 171